import GroupSection from "./GroupSection";
import SubGroupSection from "./SubGroupSection";
import {Button} from "antd";
import React from "react";
import {PresetGroupProps, PresetSubGroupProps} from "../../../types/PresetProps";

interface GroupSelectorsProps {
    presetGroups: PresetGroupProps[];
    presetSubGroups: PresetSubGroupProps[];
    onSelectGroup: (selectedGroupId: number) => void;
    selectedGroupId?: number | null;
    selectedGroup?: PresetGroupProps | null;
    onSelectSubGroup: (selectedSubGroupId: number) => () => void;
    selectedSubGroupId?: number | null;
    selectedSubGroup?: PresetSubGroupProps | null;
    onClose: () => void;
    onSubmit: () => void;
}

const GroupSelectors = ({ presetGroups, presetSubGroups, onSelectGroup, onSelectSubGroup, selectedSubGroupId, selectedGroupId, selectedSubGroup, selectedGroup, onClose, onSubmit }: GroupSelectorsProps) => {
    return (
        <div className="groups-selector-container">
            <div className="selectors">
                <GroupSection presetGroups={presetGroups} onSelectGroup={onSelectGroup} selectedGroupId={selectedGroupId} />
                <SubGroupSection selectedSubGroup={selectedSubGroup || null} subGroups={presetSubGroups.filter(subGroup => selectedGroup && subGroup.groupId === selectedGroup.id)} onSelect={onSelectSubGroup} />
            </div>
            <div className="action-bar">
                <Button type="text" size="large" onClick={onClose}>Cancel</Button>
                <Button type="primary" size="large" disabled={!selectedGroupId || !selectedSubGroupId} onClick={onSubmit} >Next</Button>
            </div>
        </div>
    )
}

export default GroupSelectors;